import React, { useState } from 'react';

import { Button } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import useEffectOnce from 'hooks/use-effect-once';
import { SyncStorageKey, _mmkvStorage, syncStorage } from 'utils/environment/sync-storage';

import { HiddenEnvItem } from './env-item';
import { HiddenSection } from './hidden-section';

const getValue = (key: any) => {
  const stringValue = _mmkvStorage.getString(key);
  const booleanValue = _mmkvStorage.getBoolean(key);
  const numberValue = _mmkvStorage.getNumber(key);

  return stringValue
    ? stringValue
    : numberValue !== undefined
    ? numberValue
    : booleanValue !== undefined
    ? booleanValue
    : undefined;
};

const LocalStorageItemsContent = () => {
  const [localStorageData, setLocalStorageData] = useState({});

  useEffectOnce(() => {
    const allData = _mmkvStorage.getAllKeys().reduce((acc, key) => {
      Object.assign(acc, { [key]: getValue(key as SyncStorageKey) });
      return acc;
    }, {});
    setLocalStorageData(allData);
  });
  return (
    <>
      <Box>
        {Object.entries(localStorageData).map(([key, value]) => (
          <Box key={key} style={styles.item}>
            <HiddenEnvItem key={key} envKey={key} value={JSON.stringify(value)} />
            <Button size="sm" onPress={() => syncStorage.remove(key as SyncStorageKey)}>
              Remove
            </Button>
          </Box>
        ))}
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  item: { paddingBottom: 8 },
});

export const LocalStorageItems = () => (
  <HiddenSection title="Sync Storage Items" content={<LocalStorageItemsContent />} />
);
